import React from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as actionCreators from './store/actions/login';
import * as actionCreatorsApp from './store/ApplicationStore';
import Layout from './Layout';
import withWindowDimensions from './hoc/withWindowDimensions';
import SessionExpirationWarning from './components/SessionExpirationWarning/SessionExpirationWarning';
import Spinner from './components/Spinner/Spinner';
import RedirectRules from './components/RedirectRules/RedirectRules';
import BrandThemeHandler from './components/BrandThemeHanlder/BrandThemeHandler';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import './styles/main.scss';
import BrandTextHandler from './components/BrandTextHandler/BrandTextHandler';
import OverdueInvoicesBanner from './components/Banner/OverDueInvoicesBanner';
import UndeliverableAddressBanner from './components/Banner/UndeliverableAddressBanner/UndeliverableAddressBanner';
const darkTheme = createTheme({
  palette: {
    mode: 'light',
  },
  typography: {
    fontSize: '1rem',
  },
});

const App = (props) => {
  // JL('jsLogger').warn("Application is starting...");

  const onNavBarSelectHandler = (act) => {
    if (act === 'logout') {
      props.logout();
      window.location.href = '/'; //real page reload to reset app state and not to remember previous link
    }
  };

  const onWebChatButtonClick = (event) => {
    // setShowWebChat(true);
    event.preventDefault();
    console.log('%Chat Bot : OpenChat event fired.', 'color: white; background-color: #26bfa5;');
    if (window.insyncSetChatEnv && typeof window.insyncSetChatEnv.openChat === 'function') {
      window.insyncSetChatEnv.openChat('OpenChat');
    }
  };

  const showExtendedFooter =
    props.location.pathname === '/submit-application' || props.location.pathname === '/guarantor-signature';

  const onExpiredHandler = () => {
    props.logout();
    props.history.push('/');
  };

  const onSessionContinue = () => {
    props.refreshToken();
  };

  const expWarning = props.sessionExpirationWarning ? (
    <SessionExpirationWarning seconds={30} onExpired={onExpiredHandler} onContinue={onSessionContinue} />
  ) : null;

//   if (props.restoringLogin === true) return <div>restoring..</div>;

  if (props.impersonating === true) return <Spinner></Spinner>;

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />

      <>
        <>
          {props.LoggedIn ? <OverdueInvoicesBanner account={props.account?.data} user={props?.CurrentUser} /> : null}
          {props.LoggedIn ? <UndeliverableAddressBanner account={props.account?.data} user={props?.CurrentUser} /> : null}
          {/* <pre>{JSON.stringify(props.CurrentUser, null, 2)}</pre> */}

          <Layout
            isUserLoggedIn={props.LoggedIn}
            isPasswordExpired={props.passwordExpired}
            showExtendedFooter={showExtendedFooter}
            hideBrand={props.themeId}
            onNavBarSelect={onNavBarSelectHandler}
            onWebChatButtonClick={onWebChatButtonClick}
          />
          {expWarning}
          <RedirectRules {...props} />
          <BrandThemeHandler {...props} />
          <BrandTextHandler {...props} />
        </>
      </>
    </ThemeProvider>
  );
};

const actions = { ...actionCreators, ...actionCreatorsApp.actionCreators };
export default withRouter(
  connect(
    (state) => {
      const { login, app, account } = state;
      return { ...login, ...app, ...account };
    },
    (dispatch) => bindActionCreators(actions, dispatch),
  )(withWindowDimensions(App)),
);
